export default __webpack_public_path__ + "static/media/heart-default-icon.18718459.svg";